export const prevent =
  (fn: () => void) =>
  (event: any): any => {
    event.preventDefault();
    return fn();
  };
